import ChatList from "./chat-list";

export default ChatList;